import React from 'react'
import { connect } from 'react-redux';
import PropagateLoader from "react-spinners/PropagateLoader";
import * as GlobalActions from '../store/actions'
import { fetchUserDetails } from "../services/service";
import { datadogLogs } from '../datadog';



class Chatbot extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: true
        }
        
       
    }

    componentDidMount() {
        // Fetch user details first
        fetchUserDetails()
            .then((response) => {
                if(response?.status === 401) {
                    this.props.logoutUser()
                    window.location.href = "/?login=true"
                    return;
                }
                
                // Log API response
                datadogLogs.logger.info('📡 fetchUserDetails response', {
                    action: 'FETCH_USER_DETAILS',
                    hasEmail: !!response.data?.email,
                    hasJWT: !!response.data?.intercom_user_jwt,
                    email: response.data?.email,
                    timestamp: new Date().toISOString()
                });
                
                // Update Redux state - this will trigger componentDidUpdate
                // which will then initialize Intercom with fresh data
                this.props.updateUserDetails(response.data);
                
                // Don't call initializeIntercom here - Redux hasn't updated yet!
                // componentDidUpdate will handle it with the correct props
            })
            .catch((error) => {
                console.error("Failed to fetch user details:", error);
                this.setState({loading: false})
            });
    }
    
    initializeIntercom = () => {
        if(this.props.globalDetails.signState &&  window.intercomSettings && this.props.globalDetails.intercomJWT && this.props.globalDetails.userEmail)
        {
            // Initialize Intercom settings with fresh data
            window.intercomSettings.name = this.props.globalDetails.userName;
            window.intercomSettings.user_id = this.props.globalDetails.userId;
            window.intercomSettings.email = this.props.globalDetails.userEmail;
            window.intercomSettings.created_at = Math.floor(Date.now() / 1000);
            window.intercomSettings.intercom_user_jwt = this.props.globalDetails.intercomJWT;
            
            // Log what we're sending to Intercom
            datadogLogs.logger.info('📨 Intercom initialized', {
                action: 'INTERCOM_INIT',
                hasEmail: !!window.intercomSettings.email,
                hasUserId: !!window.intercomSettings.user_id,
                hasJWT: !!window.intercomSettings.intercom_user_jwt,
                email: window.intercomSettings.email,
                userId: window.intercomSettings.user_id,
                timestamp: new Date().toISOString()
            });
            
            // Update Intercom settings
            if (window.Intercom) {
                window.Intercom('update', window.intercomSettings);
                window.Intercom('show');
                this.setState({loading: false})
            }

        }
        else if (window.intercomSettings && window.Intercom)
        {
            window.Intercom('shutdown');
            
            // Log why Intercom was shut down
            datadogLogs.logger.info('🔒 Intercom shutdown', {
                action: 'INTERCOM_SHUTDOWN',
                signState: this.props.globalDetails.signState,
                hasJWT: !!this.props.globalDetails.intercomJWT,
                hasEmail: !!this.props.globalDetails.userEmail,
                timestamp: new Date().toISOString()
            });
            
            if(!this.props.globalDetails.signState) {
                window.location.href = "/?login=true"
            } else {
                this.setState({loading: false})
            }
        }
    }
    
    componentDidUpdate(prevProps) {
        // Check if Redux state changed
        if (prevProps.globalDetails !== this.props.globalDetails) {
            // Log if email changed during the update
            if (prevProps.globalDetails.userEmail !== this.props.globalDetails.userEmail) {
                datadogLogs.logger.info('🔄 Email changed during session', {
                    action: 'EMAIL_CHANGED',
                    previousEmail: prevProps.globalDetails.userEmail,
                    currentEmail: this.props.globalDetails.userEmail,
                    timestamp: new Date().toISOString()
                });
            }
            
            // Reuse the same initialization logic
            this.initializeIntercom();
        }
    }
    checkEmailDomain(email) {
      
      // Regular expression to match email domain
      var domainRegex = /@([\w-]+\.)+([\w-]{2,})$/;
      
      // Extract domain from email
      var domain = email?.match(domainRegex);
      
      if (domain) {
          // Extracted domain
          domain = domain[0].substring(1);
          
          // List of allowed domains
          var allowedDomains = [
              "aviatrix.com",
              "informatica.com",
              "paccar.com",
              "medidata.com",
              "vsp.com",
              "doble.com",
              "toyotafinancial.com",
              "alkermes.com",
              "compass.com",
              "vitechinc.com",
              "mtb.com"
          ];
          
          // Check if extracted domain is in the allowed list
          if (allowedDomains.includes(domain)) {
              return true;
          }
      }
      
      // Email domain not allowed
      return false;
  }

    render() {
        let {loading} = this.state
        return (
            <React.Fragment>
           
                {loading&&
                <div style={{height: '100vh', justifyContent: 'center', alignItems: 'center', display: 'grid'}}>
                
                    <PropagateLoader  size={10} color={"#e24402"} loading={true} />
                                    
                </div>
                

                }
            </React.Fragment >
        )
    }
}




const mapStateToProps = state => ({
    globalDetails: state

})

const mapDispatchToProps = dispatch => ({
    logoutUser: (data) => dispatch(GlobalActions.logoutUser(data)),
    updateUserDetails: (data) => dispatch(GlobalActions.updateUserDetails(data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Chatbot)
